<template>
  <div class="boiler">
    <div class="content c895">
      <h2>DODAJTE GRELNIK VODE (BOJLER)</h2>
    </div>
    <div class="content c590">
      <div class="form">
        <h3>VPIŠITE PODATKE O GRELNIKU VODE (BOJLERJU)</h3>
        <div class="f-item radio spec-length">
          <label style="width:120px;">Tip grelnika vode:</label>
          <table style="float:left;" border="0">
            <tbody>
              <tr>
                <td>
                  <input
                    type="radio"
                    value="1"
                    v-model="checked"
                    @click="checker = !checker"
                    :checked="checker"
                  />
                  <label for>Pretočni grelnik vode</label>
                </td>
                <td>
                  <input
                    type="radio"
                    value="2"
                    v-model="checked"
                    @click="checker = !checker"
                    :checked="!checker"
                  />
                  <label>
                    Grelnik s hranilnikom
                    <span>(bojlerjem)</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="help">
            <a class="help" title="Help" href="#">Help</a>
            <div
              class="tooltip"
            >Pretočni grelniki pogrejejo le toliko vode, kot je potrebujemo in praktično nimajo izgub. Začetna investicija je pri teh dražja, velika je tudi priključna moč. Grelniki s hranilnikom (bojlerjem) pa imajo zaradi toplotnih izgub hranilnika večjo porabo električne energije, so pa cenejši in imajo majhno priključno moč.</div>
          </div>
        </div>
        <div class="f-item select spec-length">
          <label>
            Število članov gospodinjstva:
            <span
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err ? 'hidden' : 'visible'}"
            >*</span>
          </label>
          <select v-model="clani">
            <option value="0">Izberite</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
        </div>
        <div class="f-item select spec-length">
          <label>
            Kolikšen del leta uporabljate grelnik vode:
            <span
              id
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err2 ? 'hidden' : 'visible'}"
            >*</span>
          </label>
          <select v-model="del">
            <option value="0">Izberite</option>
            <option value="1">celo leto</option>
            <option value="2">11 mesecev</option>
            <option value="3">7 mesecev</option>
            <option value="4">6 mesecev</option>
            <option value="5">1 mesec</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>Ocena dnevne porabe tople vode v vašem gospodinjstvu za posamezna opravila. Upoštevajte navade vseh članov gospodinjstva.</p>
      </div>
      <div class="answer-list table">
        <ul>
          <li class="answer odd">
            <span class="small">UMIVANJE ROK</span>
            <div>
              <a :class="{selected: roke == 1}" @click="roke = 1">malo</a>
              <div class="tooltip-top">Ocena dnevne porabe vode na osebo za umivanje rok je 3 l.</div>
            </div>
            <div>
              <a :class="{selected: roke == 2}" @click="roke = 2">povprečno</a>
              <div class="tooltip-top">Ocena dnevne porabe vode na osebo za umivanje rok je 4,5 l.</div>
            </div>
            <div class="last">
              <a :class="{selected: roke == 3}" @click="roke = 3">veliko</a>
              <div class="tooltip-top">Ocena dnevne porabe vode na osebo za umivanje rok je 6 l.</div>
            </div>
          </li>
          <li class="answer">
            <span class="small">Osebna higiena</span>
            <div>
              <a :class="{selected: higiena == 1}" @click="higiena = 1">malo</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe vode na osebo za osebno higieno (umivanje zob, obraza, telesa itd.) je 9 l.</div>
            </div>
            <div>
              <a :class="{selected: higiena == 2}" @click="higiena = 2">povprečno</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe vode na osebo za osebno higieno (umivanje zob, obraza, telesa itd.) je 10,5 l.</div>
            </div>
            <div class="last">
              <a :class="{selected: higiena == 3}" @click="higiena = 3">veliko</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe na osebo za osebno higieno (umivanje zob, obraza, telesa itd.) je 12 l.</div>
            </div>
          </li>
          <li class="answer odd">
            <span class="small">Pomivanje posode</span>
            <div>
              <a :class="{selected: posoda == 1}" @click="posoda = 1">malo</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe vode na osebo za pomivanje posode je 4l. Ker pa je potrebno vodo za to opravilo bolj ogreti (60˙C namesto 37 ˙C), je poraba v kWh večja, kot za druga opravila.</div>
            </div>
            <div>
              <a :class="{selected: posoda == 2}" @click="posoda = 2">povprečno</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe vode na osebo za pomivanje posode je 5,5l. Ker pa je potrebno vodo za to opravilo bolj ogreti (60˙C namesto 37 ˙C), je poraba v kWh večja, kot za druga opravila.</div>
            </div>
            <div class="last">
              <a :class="{selected: posoda == 3}" @click="posoda = 3">veliko</a>
              <div
                class="tooltip-top"
              >Ocena dnevne porabe vode na osebo za pomivanje posode je 7l. Ker pa je potrebno vodo za to opravilo bolj ogreti (60˙C namesto 37 ˙C), je poraba v kWh večja, kot za druga opravila.</div>
            </div>
          </li>
          <li class="answer">
            <span class="small">Tuširanje</span>
            <div>
              <a :class="{selected: tus == 1}" @click="tus = 1">malo</a>
              <div class="tooltip-top">Ocena dnevne porabe vode na osebo za tuširanje je 30 l.</div>
            </div>
            <div>
              <a :class="{selected: tus == 2}" @click="tus = 2">povprečno</a>
              <div class="tooltip-top">Ocena dnevne porabe vode na osebo za tuširanje je 40 l.</div>
            </div>
            <div class="last">
              <a :class="{selected: tus == 3}" @click="tus = 3">veliko</a>
              <div class="tooltip-top">Dnevna poraba vode na osebo za tuširanje je 50 l.</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <div v-if="checked == '2' ">
          <div class="f-item select spec-length">
            <label>
              Velikost hranilnika:
              <span
                style="color:Red;float:none;font-size:1em;"
                :style="{visibility: !err3 ? 'hidden' : 'visible'}"
              >*</span>
            </label>
            <select v-model="hranilnik">
              <option value="0">Izberite</option>
              <option value="1">30 l</option>
              <option value="2">50 l</option>
              <option value="3">80 l</option>
              <option value="4">100 l</option>
              <option value="5">120 l</option>
            </select>
          </div>
          <div class="f-item radio">
            <div>
              <input type="checkbox" v-model="izloacija" />
              <label>Hladilnik ima nadstandardno izolacijo</label>

              <div class="help">
                <a href="#" class="help" title="Help">Help</a>
                <div
                  class="tooltip"
                >To opcijo izberite, če je zunanjost hranilnika (bojlerja) obdana z nekaj centimetri penaste obloge (namesto kovinske zunanjosti).</div>
              </div>
            </div>
          </div>
        </div>
        <input type="submit" value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O BOJLERJU</h3>
        <p>Priprava tople vode na električno energijo je pri nas izredno pogosta. V večini primerov uporabljamo večje akumulacijske grelnike vode (bojlerje), ki bi morali biti priključeni na elektriko le v času nižje dnevne tarife. Sicer so energetsko varčnejši “direktni” oz. pretočni grelniki vode, ki pa imajo večjo priključno moč in zato potrebujejo tudi večjo varovalko. Priključna moč električnih grelnikov vode se giblje od 1 kW do 6 kW.</p>

        <div class="average">
          <h4>Povprečna poraba grelnika vode</h4>
          <span>3200 kWh/leto</span>
          <p>
            <strong>388,79 € / leto</strong> (enotarifno)
            <br />
            <strong>278,00 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoilerObj from '../classes/boiler';

export default {
  data: function () {
    return {
      checker: true,
      checked: '1',
      hranilnik: '0',
      izolacija: false,
      kategorija: '0',
      del: '0',
      clani: '0',
      roke: 2,
      higiena: 2,
      posoda: 2,
      tus: 2,
      err: false,
      err2: false,
      err3: false,
    };
  },
  methods: {
    addedApplianceNum() {
      console.log('From boiler');
      const B = new BoilerObj(
        this.checked,
        this.del,
        this.clani,
        this.roke,
        this.higiena,
        this.posoda,
        this.tus,
        this.hranilnik,
        this.izolacija
      );
      this.$emit('applianceFormClicked', B);
    },
  },
};
</script>

<style>
</style>